import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import Layout from "components/Layout";
import { useState, useEffect, useRef } from "react";
import StockReport from "components/holdings/Report/StockReport";
import StrategyReport from "components/holdings/Report/StrategyReport";
import { getLastReportTab, updateLastReportTab } from "helpers";
import { ReportTabT } from "helpers/types";

export const ReportPage = () => {
  const [tab, setTab] = useState<ReportTabT>(getLastReportTab);
  const tabListRef = useRef<HTMLDivElement>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: ReportTabT) => {
    setTab(newValue);
  };

  useEffect(() => {
    updateLastReportTab(tab);
  }, [tab]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "Tab") {
        event.preventDefault();
        setTab((prevTab) => (prevTab === "stock" ? "strategy" : "stock"));
      } else if (
        event.key === "Tab" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        event.preventDefault();
        setTab((prevTab) => (prevTab === "stock" ? "strategy" : "stock"));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Layout title="Report" content="Report page">
      <TabContext value={tab}>
        <Box borderBottom={1} borderColor="divider">
          <TabList
            onChange={handleChange}
            ref={tabListRef}
            aria-label="report tabs"
          >
            <Tab label="Stock Report" value="stock" />
            <Tab label="Strategy Report" value="strategy" />
          </TabList>
        </Box>
        <TabPanel value="stock">
          <StockReport />
        </TabPanel>
        <TabPanel value="strategy">
          <StrategyReport />
        </TabPanel>
      </TabContext>
    </Layout>
  );
};

export default ReportPage;
